import api from './api';

export interface SimilarityProfile {
  id?: number;
  profile_code: string;
  profile_name: string;
  service_classification: string;
  default_max_overall: number;
  default_max_single_source: number;
  exclude_bibliography: boolean;
  exclude_quotes: boolean;
  small_matches_mode: 'none' | 'words' | 'percentage';
  small_matches_value: number | null;
  description?: string | null;
  sort_order?: number;
  is_active: boolean;
  orders_count?: number;
  created_at?: string;
  updated_at?: string;
}

export default {
  getAll(params?: any) {
    return api.get('/similarity-profiles', { params });
  },
  getById(id: number | string) {
    return api.get(`/similarity-profiles/${id}`);
  },
  create(data: Partial<SimilarityProfile>) {
    return api.post('/similarity-profiles', data);
  },
  update(id: number | string, data: Partial<SimilarityProfile>) {
    return api.put(`/similarity-profiles/${id}`, data);
  },
  delete(id: number | string) {
    return api.delete(`/similarity-profiles/${id}`);
  }
};
